module.exports = __webpack_public_path__ + "30b4a95be05fc7e382f35f9b03522d8d.mtl";